// Aderant POST /Invoices field length caps (INVALID_MODEL_STATE otherwise),
// verified on Expert_TEST (XPEN-3230). Kept here so the web guards and the
// xpens-api pre-send validation don't drift.
export const ADERANT_LINE_REFERENCE_MAXLENGTH = 20;   // line item Reference
export const ADERANT_HEADER_REFERENCE_MAXLENGTH = 30; // header InvoiceRef -> ReferenceNumber
